export default __webpack_public_path__ + "static/media/home.70372ede.svg";